var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSoundOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "black",
  fillOpacity: 0.7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.25 10.7495L11.5 13.7495H8.5V18.2495H11.5L15.25 21.2495V10.7495Z",
  stroke: "white",
  strokeWidth: 1.16,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.25 13.75L19.75 18.25",
  stroke: "white",
  strokeWidth: 1.16,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 13.75L24.25 18.25",
  stroke: "white",
  strokeWidth: 1.16,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconSoundOff;